/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_InvalidInputs */

const en_import_invalid = /** @type {(inputs: Import_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That doesn't look like a link.`)
};

const de_import_invalid = /** @type {(inputs: Import_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sieht nicht nach einem Link aus.`)
};

/**
* | output |
* | --- |
* | "That doesn't look like a link." |
*
* @param {Import_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_invalid = /** @type {((inputs?: Import_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_invalid(inputs)
	return en_import_invalid(inputs)
});